import React from 'react';
import './BoutiqButtons.scss';

const ButtonLoader = () => <div className='button-loader' />;

const BoutiqButton = ({ children, isLoading, className, ...buttonProps }) => {
	return (
		<button
			className={`boutiq-button ${className}${isLoading ? ' loading' : ''}`}
			type={buttonProps.type || 'button'}
			{...buttonProps}
			style={{
				...buttonProps.style,
				backgroundColor: buttonProps.disabled
				  ? 'rgba(0,0,0,0.32)'
				  : null
			}}>
			{isLoading ? <ButtonLoader /> : children}
		</button>
	);
};

export const FilledButton = ({ className, ...props }) => {
	return (
		<BoutiqButton
			className={`filled-button ${className}`}
			{...props}
			style={{
				...props.style,
			}}
		/>
	);
};

export const DestructiveButton = ({ className, ...props }) => {
	return (
		<BoutiqButton
			className={`destructive-button ${className}`}
			{...props}
			style={{
				...props.style,
			}}
		/>
	);
};

export const OutlinedButton = ({ className, ...props }) => {
	return (
		<BoutiqButton
			className={`outlined-button ${className}`}
			{...props}
			style={{
				...props.style,
			}}
		/>
	);
};

export const TransparentButton = ({
	children,
	isLoading,
	className,
	...buttonProps
}) => {
	return (
		<BoutiqButton
			type={'button'}
			className={`transparent-button ${className}`}
			{...buttonProps}
			style={{
				...buttonProps.style,
			}}>
			{isLoading ? <ButtonLoader /> : children}
		</BoutiqButton>
	);
};

export const ButtonBase = (props) => {
	return (
		<BoutiqButton
			{...props}
			style={{
				color: '#08B273',
				backgroundColor: '#ffffff',
				...props.style,
			}}
		/>
	);
};
